import { defineRule } from 'vee-validate'

const requiredCheckEmpty = () => {
  defineRule<string, string>(
    'required_check_empty',
    (value, targetField, ctx: any) => {
      if (!targetField) {
        return true
      }

      const targetValue = ctx.form?.[targetField]
      const targetHasValue = !isEmpty(targetValue)
      const hasValue = !isEmpty(value)

      if (!hasValue && targetHasValue) {
        return false
      }

      return true
    },
  )
}

export default requiredCheckEmpty
